module.exports = __webpack_public_path__ + "media/images/section-bg-photo-2-991a811051640e5ba7fff4a468cca5fc.jpg";